import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NavigationLink } from '@coin/shared/core/util-helpers';
import { NavigationMenuComponent } from '../navigation-menu/navigation-menu.component';

@Component({
  selector: 'admin-navigation-menu-wrapper',
  templateUrl: './navigation-menu-wrapper.component.html',
  styleUrls: ['./navigation-menu-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavigationMenuComponent]
})
export class NavigationMenuWrapperComponent {
  readonly disableNavigationLink = input<(link: NavigationLink) => boolean>(() => false);
}
